import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import ContentBlock from '~/components/Layout/Builders/ContentBlock';
import type { BlockType } from '~/types/AppData/Blocks/BlockType';
import { getKeyFromBlock } from '~/utilities/getKeyFromBlock';

type ContentBuilderType = {
  items: BlockType[];
};

export default component$<ContentBuilderType>(({ items }): JSX.Element => {
  return items.map((each, index) => (
    <ContentBlock
      key={getKeyFromBlock(each, index)}
      item={each}
      index={index}
    />
  ));
});
